var _style, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlayOverviewRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#d2332f;}\r\n\t.st1{fill:#d2332f;stroke:#d2332f;stroke-width:10;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.5,200c-2.1,0-4.3-0.7-6.4-1.4c-5-2.1-7.8-7.1-7.8-12.8V14.3c0-5,2.8-9.9,7.8-12.8c5-2.1,9.9-2.1,14.9,0.7 L172.3,88c4.3,2.8,6.4,7.1,6.4,12.1s-2.1,9.2-6.4,12.1L43.3,198C41.2,199.3,38.3,200,35.5,200z M49.7,41.2v118.4L139,100L49.7,41.2z "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "49.7,41.2 49.7,159.6 139,100 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlayOverviewRed);
export default __webpack_public_path__ + "static/media/ico-playOverviewRed.6bac8e274615fcfa4c72a1fdd26562f7.svg";
export { ForwardRef as ReactComponent };